import { createFileRoute } from '@tanstack/react-router';

import { DoctoralCommitteeBrowse } from '@/module/Author/DoctoralCommittee';

export const Route = createFileRoute('/_auth/author/_author/doctoral-committee/_doctoralCommittee/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <DoctoralCommitteeBrowse />;
}
